import { createUseStyles } from "react-jss";
import { apaTheme } from "../../constants/theme";
export const useStyles = () => {
  return createUseStyles({
    container: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: "48px",
    },
    toggleGroup: {
      display: "flex",
      gap: 8,
      "& .MuiToggleButtonGroup-grouped": {
        borderRadius: 8,
        border: "1px solid #E5E5E5",
        "&:not(:first-of-type)": {
          borderLeft: "1px solid #E5E5E5",
        },
        "&:not(:last-of-type)": {
          borderRight: "none",
        },
      },
      height: "32px",
    },
    toggleButton: {
      display: "flex",
      flexDirection: "row",
      gap: 8,
      textTransform: "none",
      borderRadius: "8px",
      color: `${apaTheme.color.background.brand.default}`,
      backgroundColor: `${apaTheme.color.background.brand.tertiary}`,
      padding: "8px",
      fontSize: "14px",
      fontWeight: 400,
      "&.Mui-selected": {
        color: `${apaTheme.color.text.brand.onBrand}`,
        backgroundColor: `${apaTheme.color.background.brand.default}`,
      },
      "&.Mui-selected:hover": {
        color: "white",
        backgroundColor: `${apaTheme.color.background.brand.default}`,
      },
    },
  })();
};
